module.exports = __webpack_public_path__ + "img/carrousel-mov-digi-8.8e3a5269.png";